import MBottomNavigation from './MBottomNavigation.vue';

export { MBottomNavigation };
export default MBottomNavigation;
